// We can change this values if resolution or card size changes
export const DEFAULT_CARD_WIDTH = 380;
export const DEFAULT_CARD_GAP = 24;
export const DEFAULT_AMOUNT_OF_CARDS_IN_WINDOW = 10;
export const DEFAULT_BUFFER = 3;
export const DEFAULT_ROW_BUFFER_FOR_GRID = 2;
export const DEFAULT_CARD_HEIGHT = 314;
